export const handleChangeFile = (e:React.ChangeEvent<HTMLInputElement>) => {

    const {files} = e.target

    if(!files) return undefined

    return files[0]

}